/**
 * Company profile for printed documents (PO, etc.).
 *
 * PLACEHOLDERS — điền số liệu thật trước khi dùng in thật.
 * Không hardcode địa chỉ/SĐT/email giả trong component UI.
 */
export type CompanyProfile = {
  legalName: string
  address: string
  phone: string
  fax: string
  email: string
  website: string
  /** Short brand line under logo (e.g. MOCPHAT / Furniture) */
  brandName: string
  brandTagline: string
  /** Default site/warehouse banner on PO print (not on PurchaseOrder model). */
  defaultSiteBanner: string
  /** Optional notice contact shown under LƯU Ý on print. */
  purchasingContactNote: string
}

export const COMPANY_PROFILE: CompanyProfile = {
  legalName: 'CÔNG TY TNHH SX MỘC PHÁT',
  address: 'TỔ 1 - ẤP SÔNG MÂY - XÃ BẮC SƠN - HUYỆN TRẢNG BOM - TỈNH ĐỒNG NAI.',
  phone: '+84 613 680 301',
  fax: '+84 613 680 301',
  email: 'info@mocphatfurniture.com',
  website: 'mocphatfurniture.com',
  brandName: 'MOCPHAT',
  brandTagline: 'Furniture',
  defaultSiteBanner: '[Điền xưởng/kho nhận hàng]',
  purchasingContactNote: '[Điền SĐT liên hệ đặt hàng]',
}
